import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserDetails {
  email?: string;
  id?: string;
  name?: string;
  [key: string]: unknown;
}

export interface UserEmailState {
  email: string;
  userInfo: UserDetails;
  loggedUserId: string;
}

export const initialState: UserEmailState = {
  email: '',
  userInfo: {},
  loggedUserId: '',
};

const userEmailSlice = createSlice({
  name: 'userEmail',
  initialState,
  reducers: {
    setUserEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setUserDetails: (state, action: PayloadAction<UserDetails>) => {
      const userData = action.payload.data || action.payload;
      // state.email = userData.email || '';
      state.userInfo = userData;
      state.loggedUserId = userData.id || '';
    },
    clearUserEmail: (state) => {
      state.email = '';
      state.userInfo = {};
      state.loggedUserId = '';
    },
  },
});

export const { setUserEmail, setUserDetails, clearUserEmail } = userEmailSlice.actions;

export default userEmailSlice.reducer;